// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.siwFilterPage {
    width: 450px;
    overflow: visible;
}

.siwNoFilterInfo {
    font-size: 15px;
    color: var(--integration-text-color);
}

.siwFilterGroupHeader {
    font-size: 16px;
    font-weight: 600;
    color: var(--integration-text-color);
    margin-bottom: 10px;
}

.siwFilterHeader {
    font-size: 15px;
    color: var(--integration-text-color);
    margin-bottom: 5px;
}

.siwMandatory {
    margin-bottom: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/app/integration/smartintegration/smartintegrationwizard/siw.filter.page.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".siwFilterPage {\n    width: 450px;\n    overflow: visible;\n}\n\n.siwNoFilterInfo {\n    font-size: 15px;\n    color: var(--integration-text-color);\n}\n\n.siwFilterGroupHeader {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--integration-text-color);\n    margin-bottom: 10px;\n}\n\n.siwFilterHeader {\n    font-size: 15px;\n    color: var(--integration-text-color);\n    margin-bottom: 5px;\n}\n\n.siwMandatory {\n    margin-bottom: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
